import React from "react";
import { Route, Switch } from "react-router-dom";
import Login from './Login.js'
import AppSideBar from './reactSettingsSideBar.js'
import AppliedRoute from "./AppliedRoute";
import NotFound from "./NotFound";
import ResetPassword from "./ResetPassword";

export default ({ childProps }) =>
  <Switch>
  <AppliedRoute path="/app" exact component={AppSideBar} props={childProps} />
  <AppliedRoute path="/login" exact component={Login} props={childProps} />
  <AppliedRoute path="/" exact component={Login} props={childProps} />
  <AppliedRoute path="/login/reset" exact component={ResetPassword} props={childProps} />
  <Route component={NotFound} />
  </Switch>;
